import type { PanelComponentId } from './panelRegistry';
import { PANEL_MENU_OPTIONS } from './panelRegistry';

interface PanelMenuProps {
  panelId: string;
  componentId: PanelComponentId;
  title?: string;
  onChange: (panelId: string, component: PanelComponentId) => void;
  onSplitHorizontal: (panelId: string) => void;
  onSplitVertical: (panelId: string) => void;
  onClose: (panelId: string) => void;
  canClose?: boolean;
}

export function PanelMenu({
  panelId,
  componentId,
  title,
  onChange,
  onSplitHorizontal,
  onSplitVertical,
  onClose,
  canClose = true,
}: PanelMenuProps) {
  return (
    <div className="panel-menu">
      {title && <div className="panel-menu-title">{title}</div>}
      <div className="panel-menu-controls">
        <button
          type="button"
          onClick={() => onSplitHorizontal(panelId)}
          title="Split horizontally (left | right)"
          className="btn"
        >
          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>┃</span>
        </button>
        <button
          type="button"
          onClick={() => onSplitVertical(panelId)}
          title="Split vertically (top / bottom)"
          className="btn"
        >
          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>━</span>
        </button>
        <button
          type="button"
          onClick={() => canClose && onClose(panelId)}
          title="Close panel"
          disabled={!canClose}
          className="btn btn-close-panel"
        >
          <span style={{ fontSize: '14px', fontWeight: 'bold' }}>✕</span>
        </button>
      </div>
    </div>
  );
}
